"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchCity = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bankCard_1 = require("../../model/bankCard");
var service_1 = require("../../../library/base/service");
var SearchCity = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(SearchCity, _super);
    function SearchCity() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取城市列表接口';
        _this.code = '101064';
        _this.desc = '获取城市列表接口';
        _this.requestParams = new bankCard_1.SearchCityRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return SearchCity;
}(service_1.BaseService));
exports.SearchCity = SearchCity;
//# sourceMappingURL=searchCity.js.map